import React from "react";
import ReactModal from "react-modal";

export default function(props) {
  return (
    <ReactModal isOpen={true} contentLabel="Payment Modal" onRequestClose={props.onRequestClose}>
      <div className="shop-confirmation-text">
        {props.children}
      </div>
      <div className="shop-confirmation-buttons">
        <button className="btn btn-success" onClick={props.onConfirm}>Yes</button>
        <button className="btn btn-info" onClick={props.onRequestClose}>Cancel</button>
      </div>
    </ReactModal>
  )
}
